import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthserviceService } from './authservice.service';
import { TranslateService } from '@ngx-translate/core';

import { leftSubMenu } from 'src/app/constants/leftSubMenuList';
import { ServicecallService, ThemeService } from 'src/app/services';

@Injectable()
export class AuthGuardService {
  public navigationTriggered: boolean;

  constructor(
    public auth: AuthserviceService,
    public router: Router,
    public translate: TranslateService,
    public service: ServicecallService,
    private _themeService: ThemeService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let moduleName =
      state.url.split('/').length > 1 ? state.url.split('/')[1] : null;
    moduleName = this.setModuleName(moduleName);
    if (!this.auth.isAuthenticated() || this.mandatoryCheck()) {
      this.router.navigate(['/login']);
      return false;
    }
    if (!this.service.routingPrivilegeCheck(moduleName)) {
      if (this.service.getPrivilegeUrl())
        this.router.navigateByUrl(this.service.getPrivilegeUrl());
      else return false;
    } else {
      if (
        moduleName === 'wiki' ||
        (moduleName === 'users' && !state.url.includes('/users/profile/')) ||
        moduleName === 'developer' ||
        moduleName === 'analytics' ||
        moduleName === 'settings' ||
        (moduleName === 'vehicles' &&
          !state.url.includes('/vehicles/profile/')) ||
        (moduleName === 'assets' && !state.url.includes('/assets/profile/')) ||
        (moduleName === 'people' && !state.url.includes('/people/profile/'))
      ) {
        const subMenuNav = state.url.slice(1);
        const queryParamsIndex = state.url.indexOf('?');
        const queryParams =
          queryParamsIndex !== -1 ? state.url.slice(queryParamsIndex) : '';
        if (!this.navigationTriggered) {
          this.navigationTriggered = true;
          if (
            !this.service.subMenuRoutingPrivilegeCheck(
              subMenuNav ? subMenuNav : null,
              moduleName
            )
          ) {
            const nextPrivilegeNav =
              [...leftSubMenu[moduleName]]?.length > 1
                ? [...leftSubMenu[moduleName]].find((item: any) =>
                    this.service?.rbacManagement(item?.privilege)
                  )?.nav
                : null;
            if (nextPrivilegeNav) {
              if (state.url !== nextPrivilegeNav + queryParams) {
                const targetUrl = queryParams
                  ? nextPrivilegeNav + queryParams
                  : nextPrivilegeNav;
                this.router
                  .navigateByUrl(targetUrl)
                  .then(() => {
                    this.navigationTriggered = false;
                  })
                  .catch((error) => {
                    this.navigationTriggered = false;
                  });
                return false;
              } else {
                this.navigationTriggered = false;
                return false;
              }
            } else {
              this.navigationTriggered = false;
              return false;
            }
          }
          this.navigationTriggered = false;
        }
      }
    }
    const domain = localStorage.getItem('domain')
      ? (localStorage.getItem('domain') || '{}').toString()
      : '';
    const tanslateJson = JSON.parse(localStorage.getItem('trans') || '{}');
    this.translate.setTranslation(domain, tanslateJson);
    this.translate.use(domain);
    // Set tenant theme
    this._themeService?.switchTheme();
    return true;
  }

  mandatoryCheck() {
    if (!localStorage.getItem('trans') || !localStorage.getItem('domain')) {
      localStorage.clear();
      sessionStorage.clear();
      return true;
    }
    return false;
  }

  setModuleName(name: any) {
    if (name.indexOf('?') > -1) {
      return name.split('?').length > 1 ? name.split('?')[0] : null;
    } else {
      return name;
    }
  }
}
